import React, { useState, useRef, useEffect } from "react";
import "../Styles/table.css";

const Table = ({
  data,
  onSelectionChanged,
  check = "paymentComplete",
  against = false,
}) => {
  const columnWidths = useRef({});
  //   const [columnWidths, setColumnWidths] = useState({});
  const [filterValues, setFilterValues] = useState({});
  const [sortOrder, setSortOrder] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [dataPerPage] = useState(10000000);
  const selectedRows = useRef([]);
  const selectedRowsAll = useRef([]);
  const [tt, ttx] = useState(0);
  const [speed, speedset] = useState(2);
  const [checked, changechecked] = useState([]);
  // const [checkedAll, changecheckedAll] = useState([])
  const [checkedAll, setCheckedAll] = useState([]);
  const [totalchecked, changetotalchecked] = useState(0);
  const [totalmim, changetotalmim] = useState(0);
  const handleSelectionChanged = () => {
    var temp = [];
    for (let index = 0; index < selectedRows.current.length; index++) {
      temp.push(selectedRows.current[index]["id"]);
    }
    onSelectionChanged(temp);
  };

  const calculatecheck = () => {
    var temp = 0;
    var temp2 = 0;
    for (let index = 0; index < selectedRowsAll.current.length; index++) {
      temp += selectedRowsAll.current[index]["amount"];
      temp2 += parseFloat(selectedRowsAll.current[index]["mimShareAmount"]);
    }
    temp = Math.round(temp * 100) / 100; // Or use temp.toFixed(2)
    temp2 = Math.round(temp2 * 100) / 100; // Or use temp2.toFixed(2)
    changetotalchecked(temp);
    changetotalmim(temp2);
  };

  const handleRowAll = (e, row, index) => {
    if (e.target.checked) {
      selectedRowsAll.current = [...selectedRowsAll.current, row];
      checkedAll[index] = true;
      calculatecheck();
    } else {
      selectedRowsAll.current = selectedRowsAll.current.filter(
        (item) => item !== row
      );
      checkedAll[index] = false;
      calculatecheck();
    }
  };

  const handleRowSelection = (e, row, index) => {
    if (e.target.checked && row[check] === against) {
      selectedRows.current = [...selectedRows.current, row];
      handleSelectionChanged(selectedRows.current);
      checked[index] = true;
    } else {
      selectedRows.current = selectedRows.current.filter(
        (item) => item !== row
      );
      handleSelectionChanged(selectedRows.current);
      checked[index] = false;
    }
  };

  const handleResize = (e, column) => {
    // console.log(columnWidths);
    // columnWidths.current[column] =  "2px";
    // e.target.offsetWidth =2;
    // setColumnWidths({
    //   ...columnWidths,
    //   [column]: e.target.style.width,
    // });
  };

  const handleFilterChange = (e, column) => {
    setFilterValues({
      ...filterValues,
      [column]: e.target.value,
    });
  };

  const handleSort = (column) => {
    let newSortOrder = {};
    if (sortOrder.column === column) {
      newSortOrder = {
        column: column,
        order: sortOrder.order === "asc" ? "desc" : "asc",
      };
    } else {
      newSortOrder = {
        column: column,
        order: "asc",
      };
    }
    setSortOrder(newSortOrder);
  };

  // Get current data

  const filteredData = data
    .filter((row) => {
      for (const [column, value] of Object.entries(filterValues)) {
        if (
          value &&
          !String(row[column]).toLowerCase().includes(value.toLowerCase())
        ) {
          return false;
        }
      }
      return true;
    })
    .sort((a, b) => {
      const column = sortOrder.column;
      if (!column) {
        return 0;
      }
      if (a[column] < b[column]) {
        return sortOrder.order === "asc" ? -1 : 1;
      }
      if (a[column] > b[column]) {
        return sortOrder.order === "asc" ? 1 : -1;
      }
      return 0;
    });
  var indexOfLastData = 0;
  indexOfLastData = currentPage * dataPerPage;
  var indexOfFirstData = 0;
  indexOfFirstData = indexOfLastData - dataPerPage;
  var currentData = 0;
  currentData = filteredData.slice(indexOfFirstData, indexOfLastData);
  // Change page
  const handlePageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  // Logic for displaying page numbers
  const pageNumbers = [];
  for (let i = 1; i <= Math.ceil(filteredData.length / dataPerPage); i++) {
    pageNumbers.push(i);
  }

  const [selectAll, setSelectAll] = useState(false);
  const [selectAllNew, setSelectAllNew] = useState(false);

  const resizingColumn = useRef(null);

  const handleSelectAllChange = (e) => {
    if (e.target.checked) {
      selectedRows.current = [
        ...currentData.filter((row) => row[check] === against),
      ];
      changechecked(currentData.map((row) => row[check] === against));
    } else {
      selectedRows.current = [];
      changechecked(currentData.map((row) => false));
    }
    handleSelectionChanged(selectedRows.current);
    setSelectAllNew(e.target.checked);
  };

  useEffect(() => {
    window.addEventListener("mousemove", handleResizeMove);
    window.addEventListener("mouseup", handleResizeEnd);
    for (let index = 0; index < data.length; index++) {
      checked.push(false);
      checkedAll.push(false);
    }
    return () => {
      window.removeEventListener("mousemove", handleResizeMove);
      window.removeEventListener("mouseup", handleResizeEnd);
    };
  }, []);

  const handleResizeMove = (e) => {
    if (resizingColumn.current) {
      document.body.classList.add("no-select");
      // console.log(columnWidths.current[resizingColumn.current])
      if (columnWidths.current[resizingColumn.current]) {
        columnWidths.current[resizingColumn.current] += e.movementX * speed;
        ttx(e.movementX);
      } else {
        columnWidths.current[resizingColumn.current] = 100;
      }
    }
  };

  const handleResizeEnd = () => {
    document.body.classList.remove("no-select");
    resizingColumn.current = null;
  };

  const handleResizeStart = (e, column) => {
    resizingColumn.current = column;
  };

  const handleSelectAll = (e) => {
    const isChecked = e.target.checked;
    setSelectAll(isChecked);

    if (isChecked) {
      // Filter rows where paymentInit and paymentComplete are true
      const filteredRows = currentData.filter(
        (row) => row.paymentInit && row.paymentComplete
      );
      selectedRowsAll.current = [...filteredRows];
      setCheckedAll(
        currentData.map((row) => row.paymentInit && row.paymentComplete)
      );
    } else {
      // Deselect all rows
      selectedRowsAll.current = [];
      setCheckedAll(currentData.map(() => false));
    }

    calculateCheck();
  };

  const calculateCheck = () => {
    let temp = 0;
    let temp2 = 0;
    for (let index = 0; index < selectedRowsAll.current.length; index++) {
      temp += selectedRowsAll.current[index]["amount"];
      temp2 += parseFloat(selectedRowsAll.current[index]["mimShareAmount"]);
    }
    temp = Math.round(temp * 100) / 100; // Or use temp.toFixed(2)
    temp2 = Math.round(temp2 * 100) / 100; // Or use temp2.toFixed(2)
    changetotalchecked(temp);
    changetotalmim(temp2);
    // Replace changetotalchecked and changetotalmim with your state update logic
  };
  return (
    <div className="table">
      <table>
        <thead>
          <tr>
            <th>
              Selected_Query
              <input
                type="checkbox"
                checked={selectAll}
                onChange={handleSelectAll}
              />
            </th>
            <th>
              <th>
                <input
                  type="checkbox"
                  checked={selectAllNew}
                  onChange={handleSelectAllChange}
                />
              </th>
            </th>
            {Object.keys(data[0]).map((column) => (
              <th
                key={column}
                style={{
                  "min-width": columnWidths.current[column] + "px" || "10px",
                }}
                onMouseDown={(e) => handleResizeStart(e, column)}
                // key={column}
                // style={{ 'max-width': columnWidths.current[column] }}
                // onMouseDown={(e) =>
                //   (e.currentTarget.style.cursor = "col-default")
                // }
                onMouseUp={(e) => (e.currentTarget.style.cursor = "default")}
                onMouseMove={(e) => {
                  e.currentTarget.style.cursor = "pointer";
                  handleResize(e, column);
                }}
                onMouseLeave={(e) => (e.currentTarget.style.cursor = "default")}
                onDoubleClick={(e) => handleResize(e, column)}
                onClick={(e) => handleResize(e, column)}
              >
                {column}
                <br />
                <input
                  type="text"
                  style={{
                    height: "30px",
                    width: "80px",
                    fontSize: "16px", // Increased font size
                    padding: "5px", // Optional for better spacing
                  }}
                  placeholder={`Filter by ${column}...`}
                  value={filterValues[column]}
                  onChange={(e) => handleFilterChange(e, column)}
                />
                <br />
                {sortOrder.column === column ? (
                  sortOrder.order === "asc" ? (
                    <span
                      title="sort"
                      className="arrow down"
                      onClick={() => handleSort(column)}
                    ></span>
                  ) : (
                    <span
                      title="sort"
                      className="arrow up"
                      onClick={() => handleSort(column)}
                    ></span>
                  )
                ) : sortOrder.order === "asc" ? (
                  <span
                    title="sort"
                    className="arrow down"
                    onClick={() => handleSort(column)}
                  ></span>
                ) : (
                  <span
                    title="sort"
                    className="arrow up"
                    onClick={() => handleSort(column)}
                  ></span>
                )}
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {currentData.map((row, index) => (
            <tr key={index}>
              <td>
                <input
                  type="checkbox"
                  checked={checkedAll[index]}
                  onChange={(e) => {
                    handleRowAll(e, row, index);
                  }}
                />
              </td>
              <td>
                <input
                  type="checkbox"
                  checked={checked[index]}
                  onChange={(e) => {
                    handleRowSelection(e, row, index);
                  }}
                />
              </td>
              {Object.values(row).map((cell, index) => (
                <td key={index}>
                  {typeof cell === "number" ? cell.toFixed(2) : String(cell)}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <p style={{ "font-size": "14px", "font-weight": "bold" }}>
        SELECTED TOTAL:{totalchecked}, SELECTED MIM SHARE:{totalmim}
      </p>
      {/* <div className="pagination">
        {pageNumbers.map((number) => (
          <a key={number} onClick={(e) => handlePageChange(e, number)} href="#">
            {number}
          </a>
        ))}
      </div> */}
    </div>
  );
};

export default Table;
